const initState = {
  approvals: [], 
}


const timesheetReducer = (state = initState, action) => {
  switch (action.type) {
    case 'FETCH_APPROVALS':
      return {
        ...state,
        approvals: action.approvals
      }
    default: 
      return state;
  }
}

export default timesheetReducer